module.exports = __webpack_public_path__ + "img/product-center-normaeai.ad808806.png";